import { createContext } from 'react';

export const tAccIdContext = createContext<string | null>(null);
